export const LOGIN_METHOD_INSTRUCTION_LINK =
  'https://moodbalance.onelink.me/vUBh?af_xp=custom&pid=web2web_payment_success&c=premium_unlock&deep_link_value=unlock_premium&af_dp=mood%3A%2F%2F'
